export const findUrlRegExp =
  /(?:https):\/\/[^\s/$.?#].[^\s]*|www\.[^\s/$.?#].[^\s]*/gim
